import { Box, Button, Grid, ImageList, ImageListItem, ImageListItemBar, Paper, Typography, useMediaQuery } from "@mui/material";
import { DragEvent, useState } from "react";
import { useAppDispatch } from "../../../app/hooks";
import { ImageInsTargetRequest } from "../../../redux/image/imageInsSlice";
import { useSelector } from "react-redux";
import { LoadState } from "../../../redux/common";
import { PRIZA_THEME } from "../../..";
import { imageUpload, imagesUploadSlice, selectImagesUpload } from "../../../redux/image/imagesUploadSlice";
import ReplayIcon from "@mui/icons-material/Replay";
import CancelIcon from "@mui/icons-material/Cancel";

export interface ElementUploadImagesProps {
    // name: string;
    back: () => void;
    target: ImageInsTargetRequest;
}

export function ElementUploadImages(props: ElementUploadImagesProps) {
    const [dragOver, setDragOver] = useState(false);
    // determines if the image is being loaded in the component
    // const [loading, setLoading] = useState(false);
    // determines if some image was loaded, and it can be uploaded
    // const [loaded, setLoaded] = useState(false);
    const [sending, setSending] = useState(false);
    const [files, setFiles] = useState<Record<string, File>>({});
    const dispatch = useAppDispatch();
    const imagesUpload = useSelector(selectImagesUpload);

    const handleDrag = (event: DragEvent) => {
        event.stopPropagation();
        event.preventDefault();
        // const target = (event.target as HTMLDivElement);
        setDragOver(event.type === "dragover");
    };
  
    const handleDrop = (event: any) => {
        event.preventDefault();
        setDragOver(false);
        const files = event.dataTransfer.files;
        for(let i = 0; i < files.length; i++) {
            handleFileChange(files[i]);
        }
    };

    const handleFileChange = (obj: any) => {
        const file = obj as File;
        // setLoading(true);
        // setLoaded(false);
        const reader = new FileReader();
        reader.onloadend = () => {
            // setLoading(false);
            // setLoaded(true);
            if(reader && reader.result && typeof reader.result === "string") {
                files[file.name] = file;
                setFiles(files);
                dispatch( imagesUploadSlice.actions.add({filename: file.name, preview: reader.result}) );
            }
        };
        reader.readAsDataURL(file);
    };

    const handleChange =  (event: any) => {
        console.log(`change ${event.target.id}`);
        const files = event.target.files;
        for(let i = 0; i < files.length; i++) {
            handleFileChange(files[i]);
        }
    };

    const images = [];
    let countUploading = 0;
    try {
        // const items = Object.values(imagesUpload.images);
        for(const item in imagesUpload.images) {
            const retry = (event: any) => {
                event.stopPropagation();
                dispatch( imagesUploadSlice.actions.retry(item) );
            };
            const remove = (event: any) => {
                event.stopPropagation();
                dispatch( imagesUploadSlice.actions.remove(item) );
            };

            const image = imagesUpload.images[item];
            let status = undefined;
            let backgroundColor = undefined;
            let message = undefined;
            let action = undefined;
            switch(image.state.state) {
                case LoadState.Loading: 
                    status = "Carregando"; 
                    backgroundColor = "rgba(0, 0, 155, 0.5)"; 
                    message = "Processando imagem";
                    countUploading++;
                    break;
                case LoadState.Loaded: 
                    status = "Carregado"; 
                    backgroundColor = "rgba(0, 155, 0, 0.5)"; 
                    message = "Imagem carregada com sucesso";
                    break;
                case LoadState.Failed: 
                    status = "Erro"; 
                    backgroundColor = "rgba(155, 0, 0, 0.5)"; 
                    message = "Erro ao carregar imagem";
                    action = <Button variant="contained" sx={{m: 1}} aria-label={"Retry"} onClick={(event) => retry(event)}>
                            <ReplayIcon />
                        </Button>;
                    break;
                default: 
                    status = "Aguardando"; 
                    backgroundColor = "rgba(0, 0, 0, 0.5)"; 
                    message = "Aguardando para o envio";
                    action = <Button variant="contained" sx={{m: 1}} aria-label={"remover"} onClick={(event) => remove(event)}>
                            <CancelIcon />
                        </Button>;
                    break;
            }
            images.push(
                <ImageListItem key={image.filename} sx={{ minHeight: 200, maxHeight: 200 }}>
                    <img src={image.preview} alt={image.filename} />
                    <ImageListItemBar
                        title={status}
                        subtitle={message}
                        sx={{ background: backgroundColor, color: "white"}}
                        actionIcon={action}
                    />
                </ImageListItem>
            );
        }
    } catch(e) {
        console.error(e);
    }

    if(sending && countUploading < 3) {
        for(const imageName in imagesUpload.images) {
            const image = imagesUpload.images[imageName];
            if(image.state.state == LoadState.NotStarted) {
                console.log(`ElementUploadImages ${JSON.stringify(props)}`);

                dispatch(imageUpload({image: image, file: files[imageName], target: props.target}));
                countUploading++;
                if(countUploading >= 3)
                    break;
            }
        }
    }

    if(countUploading == 0 && sending) {
        setSending(false);
    }

    const isSm = useMediaQuery(PRIZA_THEME.breakpoints.up("sm"));
    const isMd = useMediaQuery(PRIZA_THEME.breakpoints.up("md"));
    const isLg = useMediaQuery(PRIZA_THEME.breakpoints.up("lg"));
    const isXl = useMediaQuery(PRIZA_THEME.breakpoints.up("xl"));

    const columnCount =
        isXl ? 4 :
        isMd ? 3 :
        isLg ? 2 :
        isSm ? 1 : 1;

    const buttons = <>
        <Box key={"top-box"} sx={{ display: "flex", justifyContent: "center" }}>
            <Button variant="contained" color="warning"
                disabled={sending}
                component="span" sx={{m: 1}} aria-label={"Voltar"} 
                onClick={() => {{
                    dispatch(imagesUploadSlice.actions.clean());
                    props.back();
                }}} >
                Voltar
            </Button>
            <label htmlFor="raised-button-file">
                <Button 
                    disabled={sending}
                    variant="contained" component="span" sx={{m: 1}} aria-label={"Upload"}>
                    Selecionar Imagens
                </Button>
            </label>
            { sending
            ?   <Button variant="contained" color="error"
                    disabled={!sending}
                    component="span" sx={{m: 1}} aria-label={"Cancelar"} onClick={() => {setSending(false);}} >
                    Cancelar
                </Button>
            :   <Button variant="contained" color="success"
                    disabled={sending}
                    component="span" sx={{m: 1}} aria-label={"Enviar"} onClick={() => {setSending(true);}} >
                    Enviar
                </Button>
            }
        </Box>
    </>;


    return <Box>
        {/* <AppBar position="static" color="default" sx={{mb: 2}}>
            <Toolbar>
                <Typography variant="h6" component="div">
                Adiconar Imagens
                </Typography>
                <Box sx={{ flexGrow: 1 }} />
                <Button onClick={handleCancel}>Voltar</Button>
            </Toolbar>
        </AppBar> */}
        {buttons}
        <Paper key={"drop-box"} id="paper" elevation={3} sx={{ p: 2, mx: {xs: 2, sm: 10} }}
            onDragOver={handleDrag} onDragLeave={handleDrag} onDrop={handleDrop}
            style={{ borderColor: dragOver ? PRIZA_THEME.palette.secondary.main : PRIZA_THEME.palette.primary.main, 
                    borderStyle: dragOver ? "dashed" : "dashed",
            padding: 20, textAlign: "center", cursor: "pointer", position: "relative",
            background: PRIZA_THEME.palette.background.paper,  }} >
            <input accept="image/*" style={{ display: "none" }} id="raised-button-file" multiple type="file" onChange={handleChange} />
            {
                images.length >   0 
                ?   <Grid container justifyContent="center" style={{ marginBottom: 16 }}>
                        <ImageList variant="quilted" sx={{ p: 0, m: 0, mb: 2 }} cols={columnCount} gap={8}>
                            {images}
                        </ImageList>
                    </Grid>
                :   <Box sx={{mt: 6, mb: 6}}>
                        <Typography>Arraste uma ou mais imagens para esta caixa, ou click para selecionar</Typography>
                    </Box>
            }
        </Paper>
        {buttons}
    </Box>;
}
